import { getOidcAuthKey } from "../../../../src/utils/oidcConfig";

export const classroomSiteOidc = {
  client_id: process.env.REACT_APP_AUTHENTICATION_CLASSROOM_CLIENT_ID,
  scope: "openid email profile force-consent roles",
  brand: "code-classroom",
  allowStudentScope: true,
};

export const classroomOidcAuthKey = getOidcAuthKey(classroomSiteOidc.client_id);
